export default function getGruposPermissao() {
    return [
        { uid: "r9jrEQXznNgjrZTGCfch", nome: "Administrador" },
        { uid: "RECT03jkyTQW9B2OMz47", nome: "Técnico" },
        { uid: "fsMA3C4KiqrssZoJoL6N", nome: "Cliente" },
        { uid: "-OXwisN4fkQV3l7Uzeui", nome: "Líder" }
    ]
}
